import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7e21470b&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e21470b",
  null
  
)

export default component.exports